export default __webpack_public_path__ + "static/media/Ballroll_00181.92c0e2ec.png";